// select all DOM elements with the same class name, orf id
import {
	convertToNumber,
	getAttrDataBase,
	getAttrDataClass,
	getAttrDataId,
	getElementsByClasses,
} from "./common";

export const queryOrfElements = (parentElement, classNames, orfId, orfBase) => {
	const ORF_ID = convertToNumber(orfId);
	const ORF_BASE = convertToNumber(orfBase);

	// break class names by spaces
	const [elements, classNameArray] = getElementsByClasses(classNames);

	// filter by first class name
	const ret = [];
	for (let j = 0; j < elements.length; j += 1) {
		const e = elements[j];

		// the element must be a child of the parent sg-visualization
		if (!parentElement.contains(e)) {
			continue;
		}

		// get the classes for this element and make sure we can find each of the classes
		// in the parameters in this.
		let missingClass = false;
		const c1 = getAttrDataClass(e);
		for (let k = 1; k < classNameArray.length; k += 1) {
			if (c1.includes(classNameArray[k]) === false) {
				missingClass = true;
				break;
			}
		}
		if (missingClass) continue;

		if (ORF_ID !== -1) {
			const id = getAttrDataId(e);
			if (id !== ORF_ID) continue;
		}

		if (ORF_BASE !== -1) {
			const base = getAttrDataBase(e);
			if (base !== ORF_BASE) continue;
		}

		ret.push(e);
	}
	return ret;
};
